(ns shared.core.amelia-light.components.checkbox
  (:require [shared.core.components.checkbox :as cb]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            ["@up/base-ui/components/ui/checkbox" :refer [Checkbox]]))

(defn checkbox [{:keys [style] :as args}]
  [cb/checkbox (assoc args :style (merge {:color "rgba(0, 0, 0, 0.2)"
                                          :font-size 12
                                          :margin-right 0}
                                         style)
                           :checked-style {:color (style/color :blue :shade-1)})])

(defn up-checkbox [{:keys [form-path form-name checked on-checked-change] :as args}]
  (let [form-val- (when (and form-path form-name)
                    (re/subscribe [:form/val- form-path form-name]))
        checked? (if (nil? checked)
                   (when form-val- (boolean @form-val-))
                   checked)
        on-checked-change (or on-checked-change
                              (when (and form-path form-name)
                                (fn [v]
                                  (re/dispatch [:form/change form-path form-name (boolean v)]))))]
    [:> Checkbox (cond-> (dissoc args :form-path :form-name)
                         (not (nil? checked?)) (assoc :checked checked?)
                         on-checked-change (assoc :on-checked-change on-checked-change))]))
